/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ErrorMessageParams,
  OverlayParams,
  FieldParams,
  Error as ErrorType,
  Title,
} from './Types';

export const validateTitle = (title: Title): void => {
  if (!title || typeof title !== 'string') {
    throw new Error('title must be populated.');
  }
};

export const validateError = (error: ErrorType): void => {
  if (!error || typeof error !== 'string') {
    throw new Error('title must be populated.');
  }
};

export const validateSetValue = (setValue: (input?: any) => any): void => {
  if (!setValue || typeof setValue !== 'function') {
    throw new Error('setValue must be populated.');
  }
};

export const validateParams = (params?: any): void => {
  if (!params) {
    throw new Error('Params must be populated.');
  }
};

export const validateErrorMessageParams = (
  params: ErrorMessageParams,
): void => {
  validateParams(params);
  validateError(params.error);
};

export const validateOverlayParams = (params: OverlayParams): void => {
  validateParams(params);
  validateTitle(params.title);
};

export const validateFieldParams = (params: FieldParams): void => {
  validateParams(params);
  validateTitle(params.title);
  validateSetValue(params.setValue);
};
